import Vue from 'vue';
import createApp from './app';

Vue.config.productionTip = false;

const { app, router } = createApp();

router.onReady(function () {
  app.$mount('#app');
});
